import { render, staticRenderFns } from "./invoiceClaimDetail.vue?vue&type=template&id=199ccfb0&scoped=true&"
import script from "./invoiceClaimDetail.vue?vue&type=script&lang=js&"
export * from "./invoiceClaimDetail.vue?vue&type=script&lang=js&"
import style0 from "./invoiceClaimDetail.vue?vue&type=style&index=0&id=199ccfb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199ccfb0",
  null
  
)

export default component.exports